<template>
  <div class="cr-addresses">
    <div class="cr-container">
      <div v-if="addressLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="addressError" class="cr-detail-card__message cr-message cr-message--error">{{ addressError }}</div>
      <div v-if="serverError" class="cr-detail-card__message cr-message cr-message--error" v-html="serverError"></div>
      <div v-if="addressLoaded || $route.params.id==0" class="cr-addresses__new">
        <Form :validation-schema="schema"
               v-slot="{ errors, meta, handleSubmit }"  :initial-values="initialFormValues" :validateOnMount="false">
          <form class="cr-addresses__form cr-form" @submit.prevent="handleSubmit(saveAddress)">
          <div v-if="address.moder == 1" class="cr-form__messages">
            <div class="cr-message cr-message--done">
              Запрос отправлен.
            </div>
          </div>
          <div v-if="Object.values(errors).length > 0 " class="cr-detail-card__message cr-message cr-message--error">
            <div>
              <div v-for="error in errors" v-html="error"></div>
            </div>
          </div>
          <fieldset class="cr-form__fieldset">
            <div class="cr-form__field">
              <label class="cr-form__label" for="addressName">
                Название
                <span class="cr-form__asterisk">
                                        *
                                    </span>
              </label>
              <Field
                  class="cr-form__input" type="text" id="addressName" name="name" v-model="formData.name" />
            </div>
            <div class="cr-form__field">
              <label class="cr-form__label" for="addressCity">
                Населенный пункт
                <span class="cr-form__asterisk">
                                        *
                                    </span>
              </label>
              <div class="cr-form__search-wrapper" :class="{isFilled:cities.length > 0,  isResultShown: cities.length > 0}">
                <div class="cr-form__search">
                  <Field @input="searchCity" class="cr-form__search-input js-input-search" id="addressCity" type="text" v-model="formData.city" name="city" />
                  <button @click="formData.city=''; cities=[]" class="cr-form__search-button-delete js-button-delete" type="button">
                    <svg class="cr-form__search-icon-delete" width="20" height="20" viewBox="0 0 25 25">
                      <use xlink:href="/assets/img/svg/sprite.svg#icon-cross-3"></use>
                    </svg>
                  </button>
                </div>
                <div class="cr-form__search-result cr-search-result">
                  <div class="cr-search-result__inner">
                    <ul class="cr-search-result__list">
                      <li v-for="item in cities" class="cr-search-result__item">
                        <a  @click="selectCity(item)" class="cr-search-result__link">
                          {{ item.DISPLAY }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="cr-form__field">
              <label class="cr-form__label" for="addressStreet">
                Улица
                <span class="cr-form__asterisk">
                                        *
                                    </span>
              </label>
              <Field class="cr-form__input" type="text" id="addressStreet" v-model="formData.street" name="street" />
            </div>
            <div class="cr-form__field">
              <label class="cr-form__label" for="addressHouse">
                Дом/корпус
                <span class="cr-form__asterisk">
                                        *
                                    </span>
              </label>
              <Field class="cr-form__input" type="text" id="addressHouse" v-model="formData.house" name="house" />
            </div>
            <div class="cr-form__field">
              <label class="cr-form__label" for="addressComment">
                Комментарий
                <span class="cr-form__asterisk">
                                        *
                                    </span>
              </label>
              <Field as="textarea" name="comment"
                     class="cr-form__textarea" v-model="formData.comment" id="addressComment" rows="1"/>
            </div>
          </fieldset>
          <div class="cr-form__bottom">
            <button v-if="!address || address.moder != 1" class="cr-button" type="submit">
                                <span class="cr-button__text">
                                    Сохранить
                                </span>
            </button>
          </div>
            </form>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>

import scrollToError from "@/mixin/scrollToError.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import axios from "axios";
import { Form, Field} from 'vee-validate';
import * as yup from 'yup';
import {debounce} from "lodash";


export default {
  data: () => ({
    isSubmitting: null,
    serverError: null,
    formData: {
      name: '',
      city: '',
      street: '',
      house: '',
      comment: ''
    },
    cities: [],
    city: '',
  }),
  mixins: [scrollToError],
  components: {Form, Field},
  setup() {
    const schema = yup.object().shape({
      name: yup.string()
          .required('Название обязательно для заполнения')
          .min(2, 'Название должно содержать минимум 2 символа'),
      city: yup.string()
          .required('Город обязателен для заполнения'),
      street: yup.string()
          .required('Улица обязательна для заполнения'),
      house: yup.string()
          .required('Номер дома обязателен для заполнения'),
      comment: yup.string()
          .required('Комментарий обязателен для заполнения')
    });

    return {
      schema
    }
  },
  async created() {
    if (this.$route.params.id) {
      await this.fetchAddress(this.$route.params.id);
    }
  },
  computed: {
    ...mapGetters('address_detail', [
      'address',
      'addressLoading',
      'addressError',
      'addressLoaded'
    ]),
    initialFormValues() {
        return this.$route.params.id ? this.address : this.formData;
    }
  },
  watch: {
    address: {
      handler(newAddress) {
        if (newAddress && this.$route.params.id) {
          this.formData = { ...newAddress };
          // Сбрасываем форму с новыми значениями
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.resetForm({
                values: this.formData
              });
            }
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('address_detail', [
      'fetchAddress'
    ]),
    ...mapMutations('address_detail', [
      'SET_DATA'
    ]),
    async saveAddress(values
    ) {
        this.isSubmitting = true;
        this.serverError = null;

      const formDataToSubmit = {
        ...this.formData,
      };

      let url = '';
      if (this.$route.params.id > 0)
        url = '/api/user/address/'+this.$route.params.id+'/';
      else
        url = '/api/user/address/';
      try {
        const response = await axios.post(url, formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = 'Ошибка сервера.';
              break;
            }
            else
              this.serverError += response.data.errors[i].message+"<br>";
          }
          throw new Error(this.serverError);
        }

        this.SET_DATA({data:response.data.data});
        if (response.data.data.id != this.$route.params.id)
          await this.$router.push({
            name: 'address_detail',  // используйте актуальное имя вашего маршрута
            params: { id: response.data.data.id }
          });


      } catch (error) {
        this.serverError = error;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },
    searchCity(evt)  {
      this.city = evt.target.value;
      this.actionSearchCity();
    },
    actionSearchCity: debounce(async function()  {
      const response = await axios.post('api/order/location/', {
        'select[1]': 'CODE',
        'select[2]': 'TYPE_ID',
        'select[VALUE]': 'ID',
        'select[DISPLAY]': 'NAME.NAME',
        'additionals[1]': 'PATH',
        'filter[=PHRASE]': this.city,
        'filter[=NAME.LANGUAGE_ID]': 'ru',
        'filter[=SITE_ID]': 's1',
        version: 2,
        PAGE_SIZE: 10,
        PAGE: 0,
      }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      this.cities = response.data.data
    }, 300),
    selectCity(city) {
      this.cities = [];
      this.formData.city = city['DISPLAY'];
    },
  }
}
</script>
